<div [formGroup]="formGroup">
  <div>
    <mat-form-field>
      <input id="opkradr1" matInput placeholder="Navn" aria-label="Navn" formControlName="navn" />
      @if (formGroup.controls.navn.hasError('maxlength')) {
        <mat-error> Navn er for langt. </mat-error>
      }
    </mat-form-field>
  </div>
  <div formGroupName="adresse">
    <div>
      <mat-form-field>
        <input id="opkradr2" matInput placeholder="Adresse" aria-label="Adresse" formControlName="vejnavn" autocomplete="off" />
        @if (formGroup.controls.adresse.get('vejnavn').hasError('maxlength')) {
          <mat-error> Vejnavn er for langt. </mat-error>
        }
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <input id="opkrpostnr" matInput placeholder="Postnr." aria-label="Post Nummer" formControlName="postnr" />
        @if (formGroup.controls.adresse.get('postnr').hasError('pattern')) {
          <mat-error> Postnr. skal bestå af 4 tal. </mat-error>
        }
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <input id="betalerBy" matInput placeholder="By" aria-label="By" formControlName="by" />
      </mat-form-field>
    </div>
  </div>
</div>
